/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { View } from "react-native";
import Rodal from "rodal";
import "rodal/lib/rodal.css";

import { Button, Text } from "UpduoLibrary";
import { skaleSoftRed, skaleWhite } from "config/UpduoColors";

interface EditPublishedSkillModalProps {
  onEditPublishedSkillConfirm: Function;
  isVisible: boolean;
  onDismiss: Function;
  isDelete: boolean;
}

export default function EditPublishedSkillModal({
  onEditPublishedSkillConfirm,
  isVisible,
  onDismiss,
  isDelete = false,
}: EditPublishedSkillModalProps) {
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  const _handleSaveSummit = () => {
    onEditPublishedSkillConfirm();
    setButtonsDisabled(true);
  };

  return (
    <Rodal
      visible={isVisible}
      onClose={() => onDismiss()}
      customStyles={{
        height: 280,
        width: 460,
      }}
    >
      <View
        style={{
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          marginTop: 20,
        }}
      >
        <Text
          style={{
            textAlign: "center",
            fontSize: 18,
          }}
        >
          {"Warning: "}
          {isDelete ? "Deleting" : "Unpublishing"} {"this topic will"}
          {
            "leave one or more Summits empty. Saving will unpublish empty Summits."
          }
        </Text>
        <Text
          style={{
            textAlign: "center",
            fontSize: 18,
          }}
        >
          {isDelete ? "Delete" : "Unpublish"} {"anyway?"}
        </Text>
        <View style={{ marginHorizontal: 20 }}>
          <Button
            marginTop={30}
            disabled={buttonsDisabled}
            onPress={() => _handleSaveSummit()}
            text={isDelete ? "Delete Lesson" : "Unpublish Lesson"}
            color={skaleWhite}
            textColor={skaleSoftRed}
            borderWidth={1}
            borderColor={skaleSoftRed}
            disabledTextColor={skaleSoftRed}
            width={330}
          />
          <Button
            marginTop={20}
            disabled={buttonsDisabled}
            onPress={() => {
              setButtonsDisabled(true);
              onDismiss();
              setButtonsDisabled(false);
            }}
            text={"Cancel"}
            width={330}
          />
        </View>
      </View>
    </Rodal>
  );
}
